import React from "react";
import { useTranslations } from "next-intl";
import ProductItem from "../products/ProductItem";
import CartQuantityStepper from "../../../theme/components/CartQuantityStepper";
import ProductPrice from "../products/ProductPrice";

const CartDropdownItem = ({
  _id,
  total,
  quantity,
  configuration,
  readonly = false,
  product,
  onChangeItemQuantity,
  onRemoveItem,
  hideAvailability = false,
  shouldUseInstitutionalMigelConformity = false,
  disableNavigation = false,
}) => {
  const t = useTranslations();
  const cuttingJSON = (configuration || []).reduce(
    (accumulator, configurationItem) => {
      if (configurationItem.key === "cutting") return configurationItem.value;
      return accumulator;
    },
    undefined,
  );
  const cutting = cuttingJSON && JSON.parse(cuttingJSON);

  return (
    <div className="mb-2 py-1" style={{ marginTop: "-1.75rem" }}>
      <ProductItem
        {...product}
        shouldUseInstitutionalMigelConformity={
          shouldUseInstitutionalMigelConformity
        }
        hideAvailability={hideAvailability}
        quantity
        cutting={cutting}
        disableNavigation={disableNavigation}
      >
        <div className="dropdown--cart__product-more mt-3 border-bottom pb-2">
          <div className="product-item__more">
            {!readonly ? (
              ""
            ) : (
              <div className="gap-2 product-item__more__amount">
                <small className="fs-8 color-primary-dimmed d-inline-block">
                  {t("quantity")}
                </small>
                <div className="fw-semibold">{quantity}</div>
              </div>
            )}
          </div>
          <div className="product-item__action">
            {!readonly ? (
              <CartQuantityStepper
                quantity={quantity}
                onQuantityChanged={onChangeItemQuantity}
                onRemove={onRemoveItem}
              />
            ) : (
              ""
            )}
          </div>
          <ProductPrice price={total} />
        </div>
      </ProductItem>
    </div>
  );
};

export default CartDropdownItem;
